import React, { Component } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Avatar, Button, CssBaseline, Grid, Typography, CircularProgress, Container, Input } from '@mui/material';
import { QueuePlayNext } from '@mui/icons-material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import Api from '../../services/api';
import CustomizedSnackbars from '../../components/material-snackbars';
import HeaderMenu from '../../components/header-menu';
import { connect } from 'react-redux';
import Footer from '../../components/footer';
import { browserHistory } from '../../helpers/history';
import { FormattedMessage, injectIntl } from 'react-intl';
import { saveAs } from 'file-saver';

class OrganizationImport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      file: null
    };
    this.closeNotification = this.closeNotification.bind(this);
    this.onChangeFile = this.onChangeFile.bind(this);
    this.importModelFile = this.importModelFile.bind(this);
  }

  onFormSubmit = async e => {
    e.preventDefault();
    this.setState({ loading: true });

    let data = new FormData();

    if (this.state.file != null) {
      data.append('file', this.state.file);
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };

      Api.post('/organizations/planilhas', data, config)
        .then(result => {
          if (result.data.success) {
            const intl = this.props.intl;
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'success',
              notificationMessage: intl.formatMessage({ id: "add.success" }),
            });
          } else {
            const intl = this.props.intl;
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });
            Api.kickoff(result);
          }
        })
        .catch(err => {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
          });
        });
    } else {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "excel" })
      });
    }
  };

  importModelFile() {
    this.setState({ loading: true });
    var url = '/organizations/importfile';

    Api.get(url, {
      responseType: 'blob'
    })
      .then((response) => {
        let url = window.URL.createObjectURL(new Blob([response.data]));
        saveAs(url, 'Modelo_Organizacoes.xlsx');
        this.setState({ loading: false });
      }).catch(() => {
        this.setState({ loading: false });
      });
  }

  onChangeFile(e) {
    this.setState({ file: e.target.files[0] });
  }

  closeNotification() {
    this.setState({ openNotification: false });
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`;
    }

    return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
        >
          <div className={classes.drawerHeader} />

          <Container component='main' maxWidth='xl'>
            <CssBaseline />
            <div className={classes.paper} style={{ marginTop: 0 }}>
              <Grid container spacing={6}>
                <Grid item xs={12} sm={4}>
                  <Button variant='outlined' color='primary' onClick={browserHistory.goBack}>{<FormattedMessage id="back" />}</Button>
                </Grid>
                <Grid item xs={12} sm={4}></Grid>
                <Grid item xs={12} sm={4} ></Grid>
              </Grid>

              <Avatar className={classes.avatar}>
                <QueuePlayNext />
              </Avatar>
              <Typography component='h1' variant='h5'>
                {<FormattedMessage id="create.lote" />}
              </Typography>

              <form name='myForm' className={classes.form} style={{ maxWidth: 500 }} onSubmit={this.onFormSubmit}>
                <Button
                  fullWidth
                  variant='contained'
                  color='primary'
                  className={classes.submit}
                  onClick={this.importModelFile}
                  style={{ marginBottom: 150 }}
                >
                  {<FormattedMessage id="import.plan" />}
                </Button>

                <Input type="file" id="files" onChange={this.onChangeFile} inputProps={{ accept: '.xlsx, .xls' }} />

                <Button
                  type='submit'
                  fullWidth
                  variant='contained'
                  color='primary'
                  className={classes.submit}
                >
                  {<FormattedMessage id="import.plan.xls" />}
                </Button>
              </form>
            </div>

            {this.state.loading && (
              <Overlay>
                <CircularProgress color='secondary' />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
        <Footer />
      </div>
    );
  }
}

OrganizationImport.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
});

export default injectIntl(connect(mapStateToProps)(withStyles(Styles)(OrganizationImport)));